export const ENV = import.meta.env.MODE;
export const STRAPI_URL: string = import.meta.env.VITE_APP_STRAPI_URL || 'http://localhost:1337';
export const PAGE_URL: string = import.meta.env.VITE_APP_PAGE_URL || '';
export const IS_DEV_ENV: boolean = ENV === 'development';
